import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { useClientAuctionStore } from '@features/client/auctions/clientAuctionStore.ts';
import AuctionList from '@features/client/auctions/AuctionList.tsx';
import UserLayout from '@components/layout/UserLayout.tsx';
import { Breadcrumbs } from '@components/navigation/Breadcrumb.tsx';

const auctionSearchSchema = z.object({
  query: z.string().optional(),
  validFrom: z.string().optional(),
  validTo: z.string().optional(),
  supplierId: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AuctionSearchParams = z.infer<typeof auctionSearchSchema>;

export const Route = createFileRoute('/c/$orgId/$portalId/auctions/')({
  validateSearch: search => auctionSearchSchema.parse(search),
  beforeLoad: ctx => {
    useClientAuctionStore.getState().fetchAuctions({
      query: ctx.search.query,
      validFrom: ctx.search.validFrom,
      validTo: ctx.search.validTo,
      supplierId: ctx.search.supplierId,
      page: ctx.search.page,
      size: ctx.search.size,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('client');

  return (
    <UserLayout>
      <div className="mb-8">
        <Breadcrumbs items={[{ label: t('auctions.breadcrumb'), href: undefined }]} />
        <div className="flex items-center justify-between mb-2 mt-4">
          <h1 className="text-3xl font-bold text-main">{t('auctions.pageTitle')}</h1>
        </div>
        <p className="text-light">{t('auctions.pageDescription')}</p>
      </div>

      <AuctionList />
    </UserLayout>
  );
}
